
import { useEffect } from 'react';
import { AxiosInstance } from 'axios';
import { InternalAxiosRequestConfig } from 'axios';
import { applyWebsiteScopeHeaders } from '../lib/websiteScope';

const ACCESS_TOKEN_NAME = import.meta.env.VITE_AUTH_TOKEN_NAME || 'access_token';
const REFRESH_TOKEN_NAME = import.meta.env.VITE_REFRESH_TOKEN_NAME || 'refresh_token';

export const useAxiosInterceptors = (
  api: AxiosInstance,
  refreshAccessToken: (refreshToken: string) => Promise<string>
) => {
  useEffect(() => {
    const reqId = api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
      const access = localStorage.getItem(ACCESS_TOKEN_NAME);
      if (config.headers) {
        Object.assign(config.headers, applyWebsiteScopeHeaders({}));
        if (access) {
          config.headers['Authorization'] = `Bearer ${access}`;
        }
      }
      return config;
    });

    const resId = api.interceptors.response.use(
      (res) => res,
      async (error) => {
        const original = error.config;
        if (
          error.response?.status === 401 &&
          !original?._retry &&
          localStorage.getItem(REFRESH_TOKEN_NAME)
        ) {
          original._retry = true;
          try {
            const newAccess = await refreshAccessToken(
              localStorage.getItem(REFRESH_TOKEN_NAME) as string
            );
            original.headers = {
              ...original.headers,
              Authorization: `Bearer ${newAccess}`,
            };
            return api(original);
          } catch (refreshErr) {
            return Promise.reject(refreshErr);
          }
        }
        return Promise.reject(error);
      }
    );

    return () => {
      api.interceptors.request.eject(reqId);
      api.interceptors.response.eject(resId);
    };
  }, [api, refreshAccessToken]);
};
